import React, {useState} from 'react';
import {Box, Button, Grid, IconButton, Typography} from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {GetState} from "../../../redux/reduxhelper";
import {IS_AUTH} from "../../../redux/action/type.action";
import {useNavigate} from "react-router";
import {getAboutInfoApi} from "../../../api/ClientApi";
import {useQuery} from "react-query";
import Loading from "../../../components/Site/Loading/Loading";
import {longString} from "../../../tools/helper";

const AboutUs = () => {
    const [showMore, setShowMore] = useState(false)

    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();

    const getAboutInfo = async () => {
        try {
            const res = await getAboutInfoApi()
            return (res?.data?.data)
        } catch (e) {

        }
    }

    const {
        isLoading,
        data: aboutUs,
    } = useQuery(['about_us'], getAboutInfo);

    if (isLoading) return <Loading/>;
    const descriptionData = showMore ? aboutUs?.description : longString(aboutUs?.description, 809)

    return (

        <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: "column",
            minHeight: '600px',
            alignItems: 'center',
            justifyContent: 'center',
        }}>

            <Grid container
                  sx={{
                      display: "flex",
                      maxWidth: '1300px',
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginY: 5,
                      marginX: 'auto',
                      background: "#F4F0F8",
                      overflowX: "hidden"
                  }}>
                <Grid data-aos="fade-left"
                      data-aos-duration="2000"
                      data-aos-delay="000"
                      data-aos-once="true">


                    <Grid sx={{display: "flex", width: '100%'}}>
                        <Grid sx={{background: "#592EA9", height: "25px", width: "25%"}}></Grid>
                        <Grid sx={{background: "#FFD050", height: "25px", flexGrow: 1}}></Grid>
                        <Grid sx={{background: "#fff", height: "25px", width: '20%'}}></Grid>

                    </Grid>

                    {isAuth && <Grid sx={{textAlign: "right"}}>
                        <IconButton onClick={() => navigate('admin/dashboard/about-us')}
                                    sx={{color: "#592EA9", cursor: "pointer"}}
                        >
                            <EditOutlinedIcon/>
                        </IconButton></Grid>}
                    <Grid sx={{
                        mx: 5,
                        my: 3,
                        px: 2,
                        py: 4,
                        flexDirection: "column",
                        display: "flex",
                        position: "relative",
                    }}>
                        <Typography variant={"h5"}
                                    sx={{color: "#592EA9", fontWeight: 700, my: 2}}>{aboutUs?.title1}</Typography>
                        <Typography variant={"h4"} sx={{fontWeight: 700, my: 2}}>{aboutUs?.title2}</Typography>
                        <Typography dangerouslySetInnerHTML={{
                            __html: descriptionData.replaceAll('&zwnj;', '').replaceAll('\\n', '<br />')
                        }} sx={{color: "#6D6E76", fontSize: 17, fontWeight: 500, lineHeight: 1.7}}/>


                        <Grid>
                            <Button sx={{color: "blue", cursor: "pointer", textAlign: "right", margin: "20px 0px"}}
                                    onClick={() => setShowMore(!showMore)}>{!showMore ? "ادامه مطلب" : "کوتاه کردن"}</Button>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )

};

export default AboutUs;